import { string } from "yup";
import { FormQuestionTypeValues } from "../../enums";

export const FormQuestionTypeSchema = string().required().oneOf(FormQuestionTypeValues);
